export const Help = {
    is_number(value) {
      return /^\d{10}$/.test(value);
    },
    showMsgErrorObjet(value) {
      let msgError = [];
      for (const property in value.data.message) {
        msgError = [...msgError, value.data.message[property]];
      }
      return msgError;
    },
    convertInMoney(value){
        return new Intl.NumberFormat('de-DE').format(value)
    },
    convertDate(value){
      return new Date(value).toLocaleDateString('fr')
    },
    groupBy(value){
    const g = value.reduce((group,item)=>{
        if(group[item.name] == null){
            group[item.name]=[]
        }
        group[item.name].push(item)
        return group;
    },{})
    return g
},
calculeTotal(value) {
  let total = 0;
  value.forEach((element) => {
    total += element.revenus;
  });
  return total;
},
 getRoute(value){
  if(value === 'Superviseur'){
   return "/requete_traitee_agence";
  }else{
   return "/requete_traite_gestionnaire";
  }
 },


  };

export const statusConfig = {
    "en cours": "#00C2FF38",
    "en attente": "#FF990038",
    accepter: "#60D8BB38",
    payer:"#60D8BB38",
    impayer:'#FF00007D',
    refuse: "#FF00007D",
    Admin:"#60D8BB38",
    Personnel:"#6495F238" 
  };